// js-lead-stack-trigger.js
;(( { $, $$ }) => {
    const activeStackElClass = 'complex-lead-dynamic-stack-el_active'
    const activeTriggerClass = 'js-lead-stack-trigger_active'

    CNS.$fns.closeComplexLeadStack = function() {
        $$('.complex-lead-dynamic-stack-el').forEach(el => el.classList.remove(activeStackElClass))
        $$('.js-lead-stack-trigger').forEach(t => t.classList.remove(activeTriggerClass))
    }

    CNS.$fns.toggleComplexLeadStack = function(stackName, trigger = null) {
        CNS.$fns.closeComplexLeadStack()
        const target = $(`.complex-lead-dynamic-stack-el[data-name="${stackName}"]`)
        target?.classList.add(activeStackElClass)
        trigger?.classList.add(activeTriggerClass)
        const event = new Event('complex-lead-stack-open')
        event.targetName = stackName
        window.dispatchEvent(event)
    }

    // triggers
    $$('.js-lead-stack-trigger').forEach(trigger => {
        // console.log(trigger)
        trigger.addEventListener('click', e => {
            e.preventDefault()
            const targetName = trigger.dataset.target
            CNS.$fns.toggleComplexLeadStack(targetName, trigger)
        })

        if (trigger.classList.contains('js-lead-stack-trigger_default')) {
            trigger.click()
        }
    })

    // Closers
    $$('.complex-lead-dynamic-stack-el__closer').forEach(closer => {
        closer.addEventListener('click', e => {
            e.preventDefault()

            const parent = closer.closest('.complex-lead-dynamic-stack-el')
            if (!parent) {
                return
            }

            parent?.classList.remove(activeStackElClass)

            const name = parent.dataset.name
            const triggers = $$(`.js-lead-stack-trigger[data-target="${name}"]`)
            triggers.forEach(trigger => {
                trigger?.classList.remove(activeTriggerClass)
            })
        })
    })

})(CNS);